import Header from './components/Header';
import HeroSection from './components/HeroSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <MediaSection />
        <AboutSection />
        <TopicsSection />
        <CommentsSection />
        <UpdatesSection />
        <FaqSection />
        <RankingSection />
        <CarouselSection />
        <FeaturesSection />
        <AppSection />
        <ContactSection />
        <IndexSection />
        <CardsSection />
      </main>
      <Footer />
    </div>
  );
}